import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import Cookies from "js-cookie";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import DatePicker from "react-date-picker";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

const ProductChart = ({
  companyId,
  user_id,
  selectedDate,
  companyName,
  companyLocation,
}) => {
  const [chartKey, setChartKey] = useState(0);
  const token = Cookies.get("token")?.replace(/"/g, "");
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [chartType, setChartType] = useState("pie");
  const [chartsData, setChartsData] = useState([]);
  const [yardId, setYardId] = useState("");
  const [storeYardDetail, setStoreYardDetails] = useState([]);

  const navigate = useNavigate();

  const getYardDetails = async () => {
    const company_id = companyId;
    const BASE_URL = `${SERVER_URL}/api/com-yard/single-company-yards/${user_id}/${company_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setStoreYardDetails(result.data || []);
    } else {
      setStoreYardDetails([]);
    }
  };

  useEffect(() => {
    getYardDetails();
  }, []);

  const handleYardChange = (e) => {
    setYardId(e.target.value);
  };

  useEffect(() => {
    AOS.init();
  }, []);

  const materialColorMap = {
    "8MTR_color": "#87ceea",
    "9.1MTR_color": "#ffb7c3",
    "9.1MTR_plain": "#9ac995",
    "8MTR_plain": "#87ADD4",
  };

  const generateColors = (labels) => {
    return (
      labels?.map((label) => materialColorMap[label] || "#65B963") || [
        "#65B963",
      ]
    );
  };

  const [state, setState] = useState({
    series: [],
    options: {
      chart: {
        type: chartType,
      },
      labels: [],
      xaxis: {
        categories: [],
      },
    },
  });

  const getData = async () => {
    const renewalDate = moment(selectedDate).format("DD-MM-YYYY");
    try {
      const BASE_URL = `${SERVER_URL}/api/yard-details/product-stock-chart/${user_id}?date=${renewalDate}&yard_id=${yardId}&company_id=${companyId}`;
      const res = await fetch(BASE_URL, {
        method: "GET",
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (!res.ok) {
        throw new Error(`HTTP error! Status: ${res.status}`);
      }

      const result = await res.json();
      const materialNames = result.data.map(
        (item) => item.productDetails.productName.size
      );
      const closingStocks = result.data.map((item) => item.p_closing_stock);
      const colors = generateColors(materialNames);

      setState({
        options: {
          ...state.options,
          labels: materialNames,
          xaxis: {
            categories: materialNames,
          },
          colors: colors,
          plotOptions: {
            bar: {
              distributed: true,
            },
          },
        },
        series:
          chartType === "pie" || chartType === "donut"
            ? closingStocks
            : [
                {
                  name: "Closing Stock",
                  data: closingStocks,
                },
              ],
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const updateChartType = (type) => {
    setChartType(type);
    setState((prev) => ({
      ...prev,
      options: {
        ...prev.options,
        chart: { type },
      },
    }));
    setChartKey((prevKey) => prevKey + 1);
  };

  useEffect(() => {
    getData();
  }, [companyId, selectedDate, yardId, chartType]);

  return (
    <div className="col-md-6 grid-margin">
      <div className="card">
        <div className="card-body">
          <div className="d-flex chart-content">
            <div>
              <p className="card-title">Product Stock Report</p>
            </div>
            <div className="dropdown-charts d-flex">
              <select
                value={yardId}
                onChange={handleYardChange}
                className="form-control mr-1"
                style={{ width: "auto" }}
              >
                <option value="">Select Yard (All)</option>
                {storeYardDetail?.map((item, index) => (
                  <option value={item.id} key={index}>
                    {item.yard_name}
                  </option>
                ))}
              </select>
              <select
                value={chartType}
                onChange={(e) => updateChartType(e.target.value)}
                className="form-control"
                style={{ width: "auto" }}
              >
                <option value="donut">Donut</option>
                <option value="pie">Pie</option>
                <option value="bar">Bar</option>
              </select>
              <button
                type="button"
                onClick={() => navigate(`/yard-details?companyId=${companyId}`)}
                className="btn btn-sm btn-light btn-icon-text ml-1"
              >
                Detail<span className="mdi mdi-arrow-right"></span>
              </button>
            </div>
          </div>
          <div>
            <h4>{`${companyName}, ${companyLocation}`}</h4>
          </div>
          <div className="chart-container">
            <Chart
              key={chartKey}
              options={{
                ...state.options,
                chart: {
                  type: chartType,
                },
                colors: generateColors(state.options.labels),
                legend: {
                  markers: {
                    fillColors: generateColors(state.options.labels),
                  },
                },
              }}
              series={state.series}
              type={chartType}
              width="90%"
              height="250px"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductChart;
